import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { BulkActionsComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { useConfigurationList } from 'modules/settings/contexts/device-configuration/hooks/use-configuration-list.hook';
import { useActiveDeactivateDeviceConfiguration } from '../hooks/use-active-deactivate-device-configuration.hook';
import { useDeviceConfigurationNavigation } from '../hooks/use-device-configuration-navigation.hook';
import { BulkActivateDeactivateConfigurationComponent } from './bulk-activate-deactivate-configuration.component';
import { BulkDuplicateConfigurationComponent } from './bulk-duplicate-configuration.component';
import { BulkEditConfigurationComponent } from './bulk-edit-configuration.component';
import { BulkSetAsDefaultConfigurationComponent } from './bulk-set-default-configuration.component';

export const SettingsDevicesConfigurationsBulkActionsContainer = () => {
    const { t } = useTranslation();
    const { selectedRows, clearSelectedRows } = useConfigurationList();
    const { handleDeviceConfigSelected, handleOnCopyFrom, handleSetAsDefaultClick } =
        useDeviceConfigurationNavigation();

    const { handleActivateDeactivate, hasDefaultConfig } = useActiveDeactivateDeviceConfiguration();
    return (
        selectedRows.length > 0 && (
            <BulkActionsComponent
                options={[
                    <PocTypography key="bulk_actions_selected" element="span" variant="subtitle1">
                        {t('settings.devices.device-settings.device-config-layout.bulk.action.selected', {
                            amount: selectedRows.length,
                        })}
                    </PocTypography>,
                    <PocButton
                        key="bulk_actions_deselect"
                        variant="tertiary"
                        size="medium"
                        onClick={() => clearSelectedRows()}
                    >
                        {t(`settings.devices.device-settings.device-config-layout.bulk.action.deselect`)}
                    </PocButton>,
                ]}
            >
                <BulkSetAsDefaultConfigurationComponent
                    show={
                        selectedRows.length === 1 &&
                        !selectedRows[0].isByDefault &&
                        selectedRows.every((row) => row.active)
                    }
                    onClick={() => handleSetAsDefaultClick(selectedRows[0])}
                />
                <BulkEditConfigurationComponent
                    show={selectedRows.length === 1}
                    onClick={() => handleDeviceConfigSelected(selectedRows[0])}
                />
                <BulkDuplicateConfigurationComponent
                    show={selectedRows.length === 1}
                    onClick={() => handleOnCopyFrom(selectedRows[0])}
                />
                <BulkActivateDeactivateConfigurationComponent
                    selectedRows={selectedRows}
                    isDefaultSelected={hasDefaultConfig(selectedRows)}
                    onClick={() => handleActivateDeactivate(selectedRows)}
                />
            </BulkActionsComponent>
        )
    );
};
